import React from 'react'
import { WidgetTeaserProps } from '@/types/cms'
import styles from './TeaserInline.module.scss'
import AppContext from '@/types/context'
import { Link } from '@/components/Link'
import { Image } from '@/components/Image'

const TeaserInline = ({ item }: { item: WidgetTeaserProps; context: AppContext }) => {
  return (
    <div className={styles.wrapper}>
      {item.items?.map((teaser) => (
        <Link
          href={
            teaser.model.type === 'teaserexternal' && teaser.model.linkExternal
              ? teaser.model.linkExternal?.url
              : teaser.model.url
          }
          target={
            teaser.model.type === 'teaserexternal' && teaser.model.linkExternal
              ? teaser.model.linkExternal?.target
              : '_self'
          }
          className={styles['container']}
          key={teaser.id}
        >
          <Image
            image={teaser.model.image}
            alt={teaser.model.image?.filename || teaser.model.title}
            className={styles.image}
          />
          <div className={styles['text-container']}>
            <h3 className={styles.headline}>{teaser.model.headline}</h3>
            <span className={styles.section}>{teaser.model.homeSection}</span>
          </div>
        </Link>
      ))}
    </div>
  )
}

export default TeaserInline
